/**
 * @generated SignedSource<<6ce0dec526f6d0f43516bf0a619bcb70>>
 * @relayHash 2507344d419971f574507c46184f7d18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa260c993e91f7d86533d0a8cea0615a765e703917b12c3cc91b94536461e7e9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery } from './uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "aa260c993e91f7d86533d0a8cea0615a765e703917b12c3cc91b94536461e7e9",
    "metadata": {},
    "name": "uiGrowthRecommendPremiumToStandardModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
